import { render, staticRenderFns } from "./Itemlist.vue?vue&type=template&id=4e47f24b&"
import script from "./Itemlist.vue?vue&type=script&lang=ts&"
export * from "./Itemlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports